import React from 'react';

import { Carousel, CarouselNavigation, CarouselSlide, CarouselWrapper } from '$partials/base/carousel';
import { Image } from '$partials/media';
import { formatPrice, formatRentFrequency, formatTagBanner } from '$utilities/format';
import { Tag } from '$partials/ui';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').FeaturedPropertiesCarousel}
 */
const FeaturedPropertiesCarousel = ({
    title,
    items
}) => {
    return (
        <Carousel swiperConfig={{
            slidesPerView: 'auto',
            spaceBetween: 2,
            breakpoints: {
                640: {
                    slidesPerView: 'auto'
                },
                1024: {
                    slidesPerView: 'auto'
                }
            },
        }}>
            <div className='overflow-hidden featured-articles-carousel-container overhang-left sm-overhang-left-0 md-overhang-left-0'>
                <div className='col-12 flex items-center justify-between px5 md-px6 py5 md-py7 border-bottom grey bg-white'>
                    <h2 className='type-style-2 black'>{title}</h2>
                    <div className='hide md-show'>
                        <div className='flex flex-row items-center'>
                            <CarouselNavigation look='row'/></div>
                    </div>
                </div>
                <CarouselWrapper className='swiper-wrapper'>
                    {items?.map((item, i) => {
                        const page = item.page;

                        if (!page) { return null; }

                        const image = page.listingMedia?.[0]?.image;
                        const price = page.__typename === 'PropertyPage' ? formatPrice(page.priceGbp) : `${formatPrice(page.rentGbp)} ${formatRentFrequency(page.rentFrequency)}`;

                        return (
                            <CarouselSlide
                                className='flex carousel-slide'
                                index={i}
                                key={`featured-property-carousel-${page?.id}-${i}`}>
                                <a
                                    className='link-reset flex'
                                    href={page?.url}>
                                    {page.__typename === 'RentalPropertyPage' && (
                                        <div className='absolute top-0 ml5 md-ml6 mt5 md-mt6 z2'>
                                            <Tag title={formatTagBanner(page.publicSellingStatus, page.statusTag)}/>
                                        </div>
                                    )}
                                    {page.__typename === 'PropertyPage' && (
                                        <div className='absolute top-0 ml5 md-ml6 mt5 md-mt6 z2'>
                                            <Tag
                                                bgColor={page.publicSellingStatus === 'Sold' ? 'white' : 'yellow'}
                                                title={formatTagBanner(page.publicSellingStatus, page.statusTag)}/>
                                        </div>
                                    )}
                                    <div
                                        className='flex flex-col bg-white px5 md-px6 pt5 pb6 md-pt6 md-pb9 border-top grey carousel-item-fixed-height'>
                                        <div
                                            style={{
                                                width: `${(image?.width / image?.height)}em`
                                            }}>
                                            <div className='carousel-item-height'>
                                                <Image {...image}/>
                                            </div>
                                            <div className='mt5 sm-mt7 black'>
                                                <p className='type-style-5'>
                                                    {price}
                                                </p>
                                                <h3 className='type-style-3'>
                                                    {page?.heading}
                                                </h3>
                                                <div className='mt3'>
                                                    <p className='type-style-5'>{page?.propertyName}</p>
                                                    <p className='type-style-5'>{page?.area} {page?.outwardCode}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </CarouselSlide>
                        );
                    })}
                </CarouselWrapper>

            </div>
        </Carousel>

    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default FeaturedPropertiesCarousel;
